import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Card from '~/src/components/Main/Info/Card';
import HeaderBlock from '~/src/components/Main/Info/ProductCard/blocks/HeaderBlock';
import ImageBlock from '~/src/components/Main/Info/ProductCard/blocks/ImageBlock';
import TitleBlock from '~/src/components/Main/Info/ProductCard/blocks/TitleBlock';
import PurchaseBlock from '~/src/components/Main/Info/ProductCard/blocks/PurchaseBlock';

const DEFAULT_DESCRIPTION = 'Бесплатно доставим и настроим';

const ProductCard = (
    {
        city,
        dataTest,
        detailHandler = null,
        description = DEFAULT_DESCRIPTION,
        image,
        labels = [],
        name = '',
        orderId,
        orderHandler = () => ({}),
        orderText = 'Заказать',
        priceOptions = [],
        route,
        withSelect = true,
    },
) => {
    const [selectedOption, setSelectedOption] = useState({});
    const [loading, setLoading] = useState({
        orderStatus: false,
        isLoadingOrder: false,
    });

    useEffect(() => {
        setSelectedOption(priceOptions[0]);
    }, []);

    useEffect(() => {
        if (loading.isLoadingOrder === true) {
            orderHandler(selectedOption)
                .then(() => {
                    setLoading({ ...loading, isLoadingOrder: false });
                });
        }
    }, [loading]);

    const descriptionPrepared = (city.hasFreeDeliveryAndInstallation || description !== DEFAULT_DESCRIPTION)
        ? description
        : '';

    return (
        <Card
            dataTest={'router-item'}
            headerBlock={
                <HeaderBlock
                    detailHandler={detailHandler}
                    labels={labels}
                />
            }
            imageBlock={
                <ImageBlock
                    route={route}
                    image={image}
                    name={name}
                />
            }
            titleBlock={
                <TitleBlock
                    route={route}
                    name={name}
                />
            }
            descriptionBlock={
                <div dangerouslySetInnerHTML={{ __html: descriptionPrepared }}/>
            }
            purchaseBlock={
                <PurchaseBlock
                    dataTest={dataTest}
                    loading={loading}
                    priceOptions={priceOptions}
                    orderId={orderId}
                    orderText={orderText}
                    withSelect={withSelect}
                    selectedOption={selectedOption}
                    setLoading={setLoading}
                    setSelectedOption={setSelectedOption}
                />
            }
        />
    );
};

ProductCard.propTypes = {
    name: PropTypes.string,
    orderHandler: PropTypes.func,
    detailHandler: PropTypes.func,
    labels: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            title: PropTypes.string,
            color: PropTypes.string,
        }),
    ),
    priceOptions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            price: PropTypes.number,
            pricePromo: PropTypes.number,
            type: PropTypes.number,
            value: PropTypes.number,
        }),
    ),
    orderId: PropTypes.number,
    route: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    orderText: PropTypes.string,
    dataTest: PropTypes.string,
};

const mapState = state => ({
    city: state.city.currentCity,
});

export default connect(mapState)(ProductCard);

